import DeckboardInformationList, {
  DeckboardInformationListValue,
} from "@common/components/ListDetailViews/common/Deckboard/DeckboardDrawer/DeckboardInformationList";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { displayDate, displayTime } from "@common/utils/localTime.utils";
import { getRecurrenceValue } from "@common/utils/recurrence";
import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

type RecurrenceInfoType = DeckboardInformationListValue[];

const RecurrenceInfo = () => {
  const { t } = useTranslation();
  const { detail } = useContext(RoomsRealtimeContext);
  const location = useLocation();
  const [recurrenceData, setRecurrenceData] = useState<RecurrenceInfoType>();
  const [parentRecurrenceData, setParentRecurrenceData] =
    useState<RecurrenceInfoType>();
  const isMeetingException = location.state?.meetingException;

  useEffect(() => {
    const scheduledMeeting = detail?.meeting?.scheduledMeeting;
    const temp: RecurrenceInfoType = [
      {
        label: "Recurrence",
        value: isMeetingException
          ? "Meeting Exception*"
          : getRecurrenceValue(t, scheduledMeeting),
      },
      {
        label: isMeetingException
          ? "Meeting Exception Effective*"
          : "Effective",
        value: displayDate(
          isMeetingException
            ? scheduledMeeting?.start
            : scheduledMeeting?.parentMeeting?.start
        ),
      },
      {
        label: isMeetingException ? "Meeting Exception Time*" : "Meeting Time",
        value: `From ${displayTime(scheduledMeeting?.start)} to ${displayTime(
          scheduledMeeting?.end
        )}`,
      },
    ];
    if (getRecurrenceValue(t, scheduledMeeting, false, true))
      temp.splice(2, 0, {
        label: "Until",
        value: getRecurrenceValue(t, scheduledMeeting, false, false, true),
      });
    setRecurrenceData(temp);
    if (isMeetingException && scheduledMeeting?.parentMeeting) {
      const parentTemp: RecurrenceInfoType = [
        {
          label: "Recurrence",
          value: getRecurrenceValue(t, scheduledMeeting),
        },
        {
          label: "Effective",
          value: displayDate(scheduledMeeting.parentMeeting?.start),
        },
        {
          label: "Meeting Time",
          value: `From ${displayTime(
            scheduledMeeting.parentMeeting.start
          )} to ${displayTime(scheduledMeeting.parentMeeting.end)}`,
        },
      ];
      if (getRecurrenceValue(t, scheduledMeeting, false, false, true))
        parentTemp.splice(2, 0, {
          label: "Until",
          value: getRecurrenceValue(t, scheduledMeeting, false, false, true),
        });
      setParentRecurrenceData(parentTemp);
    }
  }, [detail?.meeting]);

  const dataSections = [recurrenceData];
  const parentDataSections = [parentRecurrenceData];

  return (
    <Grid
      container
      direction="column"
      sx={{ width: '100%', gap: "3rem", }}
    >
      <Grid
        container
        direction="column"
        sx={{ width: '100%', gap: "1rem", }}>
        {dataSections
          .filter((d) => d !== undefined)
          .map((d, i) => (
            <React.Fragment key={i}>
              {i !== 0 && <Divider />}
              <DeckboardInformationList deckboardInformationValue={d} />
            </React.Fragment>
          ))}
      </Grid>
      {isMeetingException && (
        <Grid
          container
          direction="column"
          sx={{ width: '100%', gap: "1rem", }}>
          <Typography
            component="span"
            sx={{ whiteSpace: "nowrap", fontStyle: "italic" }}
          >
            {t("Main Series")}
          </Typography>
          {parentDataSections
            .filter((d) => d !== undefined)
            .map((d, i) => (
              <React.Fragment key={i}>
                {i !== 0 && <Divider />}
                <DeckboardInformationList deckboardInformationValue={d} />
              </React.Fragment>
            ))}
        </Grid>
      )}
    </Grid>
  );
};

export default RecurrenceInfo;
